import { PRODUCT_NAME, PRODUCT_TAGLINE } from '@studio/contracts';
import { Icon } from './icons';

/** The masthead every door card opens with (design/canvas/Login.src.html). */
export function Mast() {
  return (
    <div className="mast">
      <div className="mark"><Icon name="lines" /></div>
      <div>
        <div className="p">{PRODUCT_NAME}</div>
        <div className="t">{PRODUCT_TAGLINE}</div>
      </div>
    </div>
  );
}

/** Google's four-colour G, as on their sign-in button; the colours are Google's brand marks, not ours. */
export function GoogleMark() {
  return (
    <svg className="google" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.3 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z" />
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 18.9 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.3 6.1 29.4 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
      <path fill="#4CAF50" d="M24 44c5.3 0 10.1-2 13.7-5.3l-6.3-5.2C29.3 34.9 26.8 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.6 39.6 16.2 44 24 44z" />
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4.1 5.6l6.3 5.2C41.9 35.6 44 30.3 44 24c0-1.3-.1-2.3-.4-3.5z" />
    </svg>
  );
}
